import {
  Anchor,
  Box,
  Button,
  Container,
  Divider,
  LoadingOverlay,
  Paper,
  Stack,
  Text,
  Title
} from '@mantine/core'
import Image from 'next/image'
import Link from 'next/link'
import { useRouter } from 'next/router'

import { Redirect } from '@/components/commons'
import { LoginForm } from '@/containers/forms'
import { useFetch } from '@/lib/hooks'
import { getUrlString } from '@/lib/utils'
import { useAuth } from '@/providers/AuthProvider'
import { AuthenticationProvider as AuthenticationProviderType, Site as SiteType } from '@/types'

interface Data {
  site?: SiteType
}

interface Props {
  initialData?: Data
}

export default function LoginView({ initialData }: Props) {
  // Hooks
  const router = useRouter()
  const { isAuthenticated, isValidating } = useAuth() || {}

  // Constants
  const { callbackUrl, channel, site } = router.query
  const callbackUrlSlug = getUrlString(callbackUrl)
  const siteSlug = getUrlString(site)
  const channelSlug = getUrlString(channel)

  // Fetch
  const { data: siteData } = useFetch([siteSlug ? `/${siteSlug}/` : null], {
    fallbackData: initialData?.site
  })
  const hideSignUp = !siteData?.isSignupAllowed || siteData?.privacy === 'private'

  // Actions
  // const handleSocialLogin = userData => {
  //   console.log(userData)
  // }

  // const handleSocialLoginFailure = err => {
  //   console.error(err)
  // }

  // Guards
  if (isAuthenticated && !isValidating) return <Redirect url={callbackUrlSlug || '/'} replace />

  return (
    <Container size="xs" px="xs" py="lg" sx={{ alignSelf: 'center', width: '100%' }}>
      <LoadingOverlay visible={!!isAuthenticated || !!isValidating} />

      <Box sx={{ textAlign: 'center' }}>
        <Image alt={siteData?.title} src={siteData?.logo} width={80} height={80} />
        <Title mb="lg">{siteData?.title}</Title>
      </Box>
      <Paper radius="md" p="xl" withBorder>
        {!!siteData?.authenticationProviders?.length && (
          <Stack>
            {siteData.authenticationProviders.map((authProvider: AuthenticationProviderType) => (
              <Button key={authProvider.uid} component="a" href={authProvider.url}>
                Login via {authProvider.name}
              </Button>
            ))}
            {/* <SocialButton
                label="Login com Facebook"
                provider="facebook"
                appId="1445980585870235"
                onLoginSuccess={handleSocialLogin}
                onLoginFailure={handleSocialLoginFailure}
              />
              <SocialButton
                label="Login com Google"
                provider="google"
                appId="332744668651-h0ujd082jr8dtlqpvugqqpduh9qipnnb.apps.googleusercontent.com"
                onLoginSuccess={handleSocialLogin}
                onLoginFailure={handleSocialLoginFailure}
              /> */}
          </Stack>
        )}

        {siteData?.allowPasswordAuthentication && (
          <>
            {!!siteData?.authenticationProviders?.length && (
              <Divider label="Ou continue com e-mail" labelPosition="center" my="lg" />
            )}

            <LoginForm.Login />

            <Box hidden={hideSignUp}>
              <Divider my="lg" />
              <Text size="sm" color="gray">
                Não tem uma conta?{' '}
                <Anchor
                  component={Link}
                  href={`/accounts/signup${callbackUrlSlug ? `?callbackUrl=${callbackUrlSlug}` : ''}${channelSlug ? `&channel=${channelSlug}` : ''}`}>
                  Cadastre-se
                </Anchor>
              </Text>
            </Box>
          </>
        )}
      </Paper>
    </Container>
  )
}
